import React, { useEffect, useLayoutEffect } from 'react';
import { AliveScope, KeepAlive } from 'react-activation';
import { useLocation, useModel } from '@umijs/max';
import { onRemoteMenuReady } from '@/services/session';
import TagsView from '@/components/TagsView';
import { getRouteTitle, getViewPath, isTagsViewExcluded, normalizePathname } from '@/utils/routeUtil';
import './index.less';

const KeepAliveTabs: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const location = useLocation();
  const pathname = normalizePathname(location.pathname);
  const { addView, refreshAllTitles } = useModel('tagsViewModel');
  const cacheKey = getViewPath(pathname, location.search);

  useLayoutEffect(() => {
    if (isTagsViewExcluded(pathname)) {
      return;
    }
    addView({
      pathname,
      search: location.search,
      title: getRouteTitle(pathname),
    });
  }, [addView, cacheKey, pathname, location.search]);

  useEffect(() => {
    refreshAllTitles();
    return onRemoteMenuReady(refreshAllTitles);
  }, [refreshAllTitles]);

  if (isTagsViewExcluded(pathname)) {
    return <>{children}</>;
  }

  return (
    <AliveScope>
      <div className="keep-alive-tabs">
        <TagsView />
        <div className="keep-alive-tabs-content">
          <KeepAlive id={cacheKey} name={cacheKey} saveScrollPosition="screen">
            {children}
          </KeepAlive>
        </div>
      </div>
    </AliveScope>
  );
};

export default KeepAliveTabs;
